var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXClose0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4713 4.47138C12.7317 4.21103 12.7317 3.78892 12.4713 3.52858C12.211 3.26823 11.7889 3.26823 11.5285 3.52858L7.99992 7.05717L4.47132 3.52858C4.21097 3.26823 3.78886 3.26823 3.52851 3.52858C3.26816 3.78892 3.26816 4.21103 3.52851 4.47138L7.05711 7.99998L3.52851 11.5286C3.26816 11.7889 3.26816 12.211 3.52851 12.4714C3.78886 12.7317 4.21097 12.7317 4.47132 12.4714L7.99992 8.94279L11.5285 12.4714C11.7889 12.7317 12.211 12.7317 12.4713 12.4714C12.7317 12.211 12.7317 11.7889 12.4713 11.5286L8.94273 7.99998L12.4713 4.47138Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXClose0);
export default __webpack_public_path__ + "static/media/x-close0.03e2446fc5f00f7f586e5a9c6f1701e2.svg";
export { ForwardRef as ReactComponent };